// Make dots interactive - Dynamic with section IDs
document.addEventListener('DOMContentLoaded', function() {
  // Find all sections that contain sliders
  const sliderSections = document.querySelectorAll('[id^="shopify-section-"] .slider');
  
  sliderSections.forEach((slider, sectionIndex) => {
    // Get the parent section ID to make it unique
    const section = slider.closest('[id^="shopify-section-"]');
    if (!section) return;
    
    const sectionId = section.id;
    
    // Get elements within this specific section
    const dots = section.querySelectorAll('.slider-counter__link--dots');
    const slides = section.querySelectorAll('.slider__slide');
    const prevButton = section.querySelector('.slider-button--prev');
    const nextButton = section.querySelector('.slider-button--next');
    const currentSpan = section.querySelector('.slider-counter--current');
    
    if (!dots.length || !slides.length) return;
    
    // Function to update active dot for this section
    function updateActiveDot(index) {
      // Update dots
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('slider-counter__link--active');
        } else {
          dot.classList.remove('slider-counter__link--active');
        }
      });
      
      // Update counter text if it exists
      if (currentSpan) {
        currentSpan.textContent = index + 1;
      }
      
      // Dispatch custom event for other scripts to listen to
      section.dispatchEvent(new CustomEvent('sliderChanged', { 
        detail: { currentIndex: index, totalSlides: slides.length }
      }));
    }
    
    // Add click events to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Scroll to slide
        if (slides[index]) {
          slides[index].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          
          updateActiveDot(index);
        }
      });
    });
    
    // Handle next button click
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        const currentActive = Array.from(dots).findIndex(dot => 
          dot.classList.contains('slider-counter__link--active')
        );
        
        let nextIndex = currentActive + 1;
        if (nextIndex >= slides.length) nextIndex = 0; // Loop back to first
        
        if (slides[nextIndex]) {
          slides[nextIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          
          updateActiveDot(nextIndex);
        }
      });
    }
    
    // Handle prev button click
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        const currentActive = Array.from(dots).findIndex(dot => 
          dot.classList.contains('slider-counter__link--active')
        );
        
        let prevIndex = currentActive - 1;
        if (prevIndex < 0) prevIndex = slides.length - 1; // Loop to last
        
        if (slides[prevIndex]) {
          slides[prevIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          
          updateActiveDot(prevIndex);
        }
      });
    }
    
    // Optional: Update active dot on scroll (for touch/swipe)
    let scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        // Find which slide is most visible
        const sliderRect = slider.getBoundingClientRect();
        let mostVisibleIndex = 0;
        let maxVisibleArea = 0;
        
        slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const visibleWidth = Math.min(slideRect.right, sliderRect.right) - 
                              Math.max(slideRect.left, sliderRect.left);
          
          if (visibleWidth > maxVisibleArea) {
            maxVisibleArea = visibleWidth;
            mostVisibleIndex = index;
          }
        });
        
        updateActiveDot(mostVisibleIndex);
      }, 100);
    });
    
    // Initialize first dot as active
    updateActiveDot(0);
  });
});

// Also initialize after Shopify AJAX loads (for theme sections)
document.addEventListener('shopify:section:load', function(event) {
  const newSection = event.target;
  const slider = newSection.querySelector('.slider');
  
  if (slider) {
    // Re-run initialization for this specific section
    const dots = newSection.querySelectorAll('.slider-counter__link--dots');
    const slides = newSection.querySelectorAll('.slider__slide');
    
    if (dots.length && slides.length) {
      // Set first dot as active
      dots.forEach((dot, i) => {
        if (i === 0) {
          dot.classList.add('slider-counter__link--active');
        } else {
          dot.classList.remove('slider-counter__link--active');
        }
      });
    }
  }
});